import {IForm} from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'content',
      type: 'input',
      label: '发送内容',
      placeholder: '请输入发送内容',
      rules: {required: true, message: '发送内容是必传的', trigger: 'blur'}
    },
    {
      field: 'sendTime',
      type: 'datepicker',
      label: '发送时间',
      placeholder: '请选择发送时间',
      rules: {required: true, message: '发送时间是必选的', trigger: 'blur'},
      otherOptions: {
        placeholder: '请选择发送时间',
        type: 'datetime',
        'value-format': 'YYYY-MM-DD HH:mm:ss'
      }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
